import { useTranslation } from "@flare/i18n";

import { ActionButton } from "../components/action-button";
import { ActionsContainer } from "../components/actions-container";
import { BackButton } from "../components/back-button";
import { Footer } from "../components/footer";
import { PrivacyDisclaimer } from "../components/privacy-disclaimer";
import { StepContainer } from "../components/step-container";
import { StepContent } from "../components/step-content";
import { StepSubtitle } from "../components/step-subtitle";
import { StepTitle } from "../components/step-title";
import { funnelInputsNameMap } from "../config";

import { ChoiceBoxContent } from "./components/choice-box-content";

export default function DivorceAgreementStatus() {
  const { t } = useTranslation();
  const choices = [
    {
      label: t("FUNNEL_DIVORCE_AGREEMENT_STATUS_CHOICE1"),
      value: "We agree on most things",
    },
    {
      label: t("FUNNEL_DIVORCE_AGREEMENT_STATUS_CHOICE2"),
      value: "We're navigating some disagreements",
    },
    {
      label: t("FUNNEL_DIVORCE_AGREEMENT_STATUS_CHOICE3"),
      value: "We're far apart on major issues",
    },
    {
      label: t("FUNNEL_DIVORCE_AGREEMENT_STATUS_CHOICE4"),
      value: "We haven't started discussing terms yet",
    },
  ];

  return (
    <>
      <StepContainer>
        <StepContent>
          <BackButton />
          <StepTitle>{t("FUNNEL_DIVORCE_AGREEMENT_STATUS_TITLE")}</StepTitle>
          <StepSubtitle className="mb-sp-0 mt-sp-1">
            {t("FUNNEL_DIVORCE_AGREEMENT_STATUS_SUBTITLE")}
          </StepSubtitle>
          <ChoiceBoxContent
            name={funnelInputsNameMap.divorceAgreementStatus}
            choices={choices}
            required
          />
        </StepContent>
        <ActionsContainer>
          <PrivacyDisclaimer />
          <ActionButton>{t("FUNNEL_ACTION_BUTTON_NEXT")}</ActionButton>
        </ActionsContainer>
      </StepContainer>
      <Footer />
    </>
  );
}
